import type { ReactNode } from 'react';

export const symbol_earthquake: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M360.5-80q-10.5 0-18.48-5.63Q334.04-91.25 331-101L228-450H110q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-510 110-510h140q9.92 0 17.93 5.62 8.02 5.63 11.07 15.38l76 256 136-623q2-11 10.25-17.5T520-880q10.5 0 18.75 6T549-857l94 423 68-225q3.06-9.75 11.09-15.38 8.03-5.62 17.97-5.62t17.44 5q7.5 5 10.5 14l54 151h28q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-50q-9.85 0-17.42-5.5Q775-461 772-470l-30-83-74 252q-2.89 9.63-10.83 15.81-7.95 6.19-18.06 5.19T621-287q-8-6-10-16l-91-402-131 602q-2.25 10.39-10.12 16.32Q371-80.74 360.5-80Z"
		/>
	</svg>
);
